import { NgModule } from '@angular/core';
import { ShowOnSizeDirective } from './showOnSize.directive';
import { FlexChildDirective, FlexDirective } from './flex.directive';
import { BottomSheetDraggableDirective } from './bottom-sheet-draggable.directive';
import { ApplyClassOnSizeDirective } from './apply-class-on-size.directive';
import { FeatureFlagDirective } from './feature-flag.directive';
import { AutoGrowTextareaDirective } from './auto-grow-textarea.directive';

@NgModule({
  declarations: [
    AutoGrowTextareaDirective,
    FeatureFlagDirective,
    ApplyClassOnSizeDirective,
    ShowOnSizeDirective,
    FlexDirective,
    FlexChildDirective,
    BottomSheetDraggableDirective
  ],
  exports: [
    AutoGrowTextareaDirective,
    FeatureFlagDirective,
    ApplyClassOnSizeDirective,
    ShowOnSizeDirective,
    FlexDirective,
    FlexChildDirective,
    BottomSheetDraggableDirective,
  ],
})
export class SharedDirectivesModule {
}
